var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: {
        tree: true,
        "tree-loading": this.loading,
        "tree--draggable": !!this.draggableNode,
      },
      attrs: { role: "tree" },
    },
    [
      _vm.filter && _vm.matches.length == 0
        ? [
            _c("div", {
              staticClass: "tree-filter-empty",
              domProps: { innerHTML: _vm._s(_vm.opts.filter.emptyText) },
            }),
          ]
        : [
            _c(
              "ul",
              { staticClass: "tree-root", on: { dragstart: _vm.onDragStart } },
              [
                _vm.opts.filter.plainList && _vm.matches.length > 0
                  ? _vm._l(_vm.visibleMatches, function (node) {
                      return _c("TreeNode", {
                        key: node.id,
                        attrs: { node: node, options: _vm.opts },
                      })
                    })
                  : _vm._l(_vm.visibleModel, function (node) {
                      return _c("TreeNode", {
                        key: node.id,
                        attrs: { node: node, options: _vm.opts },
                      })
                    }),
              ],
              2
            ),
          ],
      _vm._v(" "),
      _vm.draggableNode
        ? _c("DraggableNode", { attrs: { target: _vm.draggableNode } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }